(function() { window.GUID_9179e00b_f1a9_4e22_a6fc_4bb3c6ff813d = { getGuid: function() { return "9179e00b-f1a9-4e22-a6fc-4bb3c6ff813d"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-comparedresults",
                        callback: (accordion, e) => {
                            const $tabmenu = accordion.$Container.find(".tabmenu.control-cs:not(.compared-results-tabmenu)");
                            accordion.SetContentSticky($tabmenu);
                            accordion.$Control.offon(`click.${accordion.UniqueInstanceId}`, ".tabmenu.control-cs .tab-menu-item", (e) => {
                                const $item = $(e.currentTarget);
                                const timePeriod = $item.attr("id");
                                const isHighlighted = $item.hasClass("is-highlighted");
                                if (!isHighlighted) {
                                    $item.addClass("is-highlighted");
                                    $item.siblings().removeClass("is-highlighted");
                                    switch (timePeriod) {
                                        case "all":
                                            accordion.$Content
                                                .find(".compared-results__body .all-time")
                                                .css({ display: "" });
                                            accordion.$Content
                                                .find(".compared-results__body .recent")
                                                .css({ display: "none" });
                                            break;
                                        case "last-year":
                                            accordion.$Content
                                                .find(".compared-results__body .recent")
                                                .css({ display: "" });
                                            accordion.$Content
                                                .find(".compared-results__body .all-time")
                                                .css({ display: "none" });
                                            break;
                                        default:
                                    }
                                }
                            });
                            ComparedResultsSection.SetContentV2(accordion);
                        },
                    });
                    let ComparedResultsSection;
                    (function (ComparedResultsSection) {
                        function SetContentV2(accordion) {
                            const $statCanvas = accordion.$Content.find(".stat-container canvas");
                            const colors = CS.Helper.DataVisualizationHelper.getColors(2);
                            const width = 1200;
                            const marginTop = 0;
                            const marginRight = 0;
                            const marginBottom = 0;
                            const marginLeft = 0;
                            if ($statCanvas.length) {
                                $statCanvas.each((index, canvas) => {
                                    const $canvas = $(canvas);
                                    let $chartContainer = $canvas.closest(".canvas-container");
                                    const $statContainer = $canvas.closest(".stat-container");
                                    let chartContainerId = $chartContainer.attr("id");
                                    if (!chartContainerId) {
                                        chartContainerId = CS.Helper.generateRandomId();
                                        $chartContainer.attr("id", chartContainerId);
                                    }
                                    $canvas.css({ display: "none" });
                                    $chartContainer.addClass("stat-container__chart");
                                    const _valueA = $statContainer.attr("data-chart-value-a");
                                    const _valueB = $statContainer.attr("data-chart-value-b");
                                    if (!_valueA || !_valueB)
                                        return;
                                    const valueA = Number(_valueA.replace(",", "."));
                                    const valueB = Number(_valueB.replace(",", "."));
                                    let total = valueA + valueB;
                                    const datapoints = [
                                        {
                                            stackId: "0",
                                            seriesId: "A",
                                            value: valueA,
                                            isStacked: false,
                                        },
                                        {
                                            stackId: "0",
                                            seriesId: "B",
                                            value: valueB,
                                            isStacked: true,
                                        },
                                    ];
                                    const comparedValueBarChart = new CS.Controls.ComparedValueBarChart({
                                        colors: colors,
                                        containerElementId: chartContainerId,
                                        datapoints: datapoints,
                                    });
                                    comparedValueBarChart
                                        .init()
                                        .then(() => {
                                        CS.Helper.log('ComparedResults', "ComparedValueBarChart.init() done");
                                    })
                                        .catch((error) => {
                                        console.error("ComparedValueBarChart.init() error", error);
                                    });
                                });
                            }
                        }
                        ComparedResultsSection.SetContentV2 = SetContentV2;
                    })(ComparedResultsSection = WallSections.ComparedResultsSection || (WallSections.ComparedResultsSection = {}));
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=compared-results.js.map
